export default __webpack_public_path__ + "static/media/sanitizer4.0aa9965b.jpg";